<template>
  <div class="m-popover" v-if="visible" :style="[position]">
    <div
      class="m-popover_content"
      :style="{
        '--borderRadius': radiusNum
      }"
    >
      <slot></slot>
    </div>
    <div class="m-popover_arrow"></div>
  </div>
</template>

<script>
import { isFunction } from '@/utils/is';

export default {
  props: {
    radiusNum: {
      type: String,
      default: '0px'
    },
    position: {
      type: Object,
      default: () => ({})
    },
    container: {
      type: [HTMLElement, null],
      default: () => null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      isFunction(done) && done();
    }
  },
  mounted() {
    if (this.container) {
      this.container.appendChild(this.$el);
    }

    // document.body.addEventListener('click', this.handleClose);
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.m-popover {
  --width: 300px;
  --height: 180px;

  --bg-color: #000;
  --border-color: #047eba;

  --arrow-size: 26px;

  position: absolute;
  z-index: 9;

  width: calc(var(--width) + var(--arrow-size));

  &_content {
    // border-radius: 20px;

    width: var(--width);
    height: var(--height);

    background: var(--bg-color);
    border-radius: var(--borderRadius);
    border: 1px solid var(--border-color);
  }

  &_arrow {
    position: absolute;
    right: -1px;
    top: 30%;
    z-index: 9;

    width: 0;
    height: 0;

    border-left: var(--arrow-size) solid var(--border-color);
    border-top: calc(var(--arrow-size) / 2) solid transparent;
    border-bottom: calc(var(--arrow-size) / 2) solid transparent;

    &::after {
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      right: 2px;
      top: 0;
      transform: translateY(-50%);
      border-left: calc(var(--arrow-size) - 2px) solid var(--bg-color);
      border-top: calc((var(--arrow-size) - 2px) / 2) solid transparent;
      border-bottom: calc((var(--arrow-size) - 2px) / 2) solid transparent;
    }
  }
}
</style>
